import React from 'react';

function Refund() {
  return (
    <div
      className="refund-page"
      style={{
        maxWidth: 700,
        margin: '2rem auto',
        padding: '2rem',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 2px 16px rgba(44,62,80,0.08)'
      }}
    >
      <h1 style={{ color: '#DA291C', marginBottom: '1.5rem' }}>Cancellation &amp; Refund Policy</h1>

      <p>
        Program enrolment is non-transferable. Refund eligibility, timelines, and process depend on
        the specific program policy communicated at the time of registration.
      </p>

      <h2>Cancellation</h2>
      <ul>
        <li>Cancellation requests must be submitted from your registered email address.</li>
        <li>Requests are reviewed based on the terms shared for your selected program.</li>
        <li>Access to learning resources may be restricted after cancellation is confirmed.</li>
      </ul>

      <h2>Refunds</h2>
      <ul>
        <li>Approved refunds are processed to the original payment method.</li>
        <li>Processing timelines can vary based on your payment provider and banking partner.</li>
        <li>Any applicable taxes or payment gateway charges may be handled as per program terms.</li>
      </ul>

      <h2>Need Help?</h2>
      <p>
        For refund or cancellation requests, contact{' '}
        <a href="mailto:support@leadwithtech.in">support@leadwithtech.in</a>.
      </p>
      <p>
        You can also review related details in our{' '}
        <a
          href="https://leadwithtech.in/terms-and-conditions-of-use/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
        .
      </p>
    </div>
  );
}

export default Refund;
